import { IonContent, IonPage, IonRouterOutlet } from "@ionic/react";
import React, { Suspense } from "react";

import "./UserChatMainPage.scss";

import { Route } from "react-router-dom";
import { utilService } from "../../../services/utilService";
import UserChatComponent from "../UserChatPage";
import UserChatWebComponent from "../UserChatWebComponent/UserChatWebComponent";

const UserChatMainPage = () => {
  return (
    <IonPage className="user-chat-main-page">
      <IonContent>
        <div className="app-height">
          <div className="controller-container">
            <div className="schedule-controller-container">
              <IonRouterOutlet>
                <Suspense fallback={""}>
                  {!utilService.isWeb() && (
                    <Route
                      exact
                      path="/client/messages"
                      component={UserChatComponent}
                    />
                  )}
                  {utilService.isWeb() && (
                    <Route
                      exact
                      path="/client/messages"
                      component={UserChatWebComponent}
                    />
                  )}
                </Suspense>
              </IonRouterOutlet>
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default UserChatMainPage;
